module.exports = __webpack_public_path__ + "static/media/DINOT-Light.548451aa.woff2";